<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
export default {
  name: "App",
  data() {
    return {};
  }
};
</script>

<style>
#app {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
  height: 100%;
}
body {
  overflow: hidden;
}
.Layout {
  height: 100%;
}
.ant-layout {
  height: 100%;
}
.ant-table-tbody > tr > td {
  padding: 11px 16px;
}
/* //弹框头部样式 */
.ant-modal-header {
  background: #5976b1 !important;
}
.ant-modal-title,
.ant-modal-close-x {
  color: #ffffff !important;
}
/* 、、、、、、、、、、 */
</style>



// WEBPACK FOOTER //
// src/App.vue